(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bulk-order-request"] && !Shopify.designMode) return;
  try {
    
  (()=>{const roots=document.querySelectorAll('[data-bulk-order]');roots.forEach(root=>{const search=root.querySelector('[data-bulk-search]'),results=root.querySelector('[data-bulk-results]'),items=root.querySelector('[data-bulk-items]'),count=root.querySelector('[data-bulk-count]'),body=root.querySelector('[data-bulk-body]'),form=root.querySelector('form'),error=root.querySelector('[data-bulk-error]'),spinner=root.querySelector('[data-bulk-spinner]');const chosen=new Map();let timer;
    const labels={add:root.ownerDocument.documentElement.lang.startsWith('ar')?'إضافة':'Add',qty:root.ownerDocument.documentElement.lang.startsWith('ar')?'الكمية':'Quantity',remove:root.ownerDocument.documentElement.lang.startsWith('ar')?'إزالة':'Remove',empty:items.textContent.trim(),selected:root.ownerDocument.documentElement.lang.startsWith('ar')?'منتج مختار':'selected'};
    const render=()=>{count.textContent=chosen.size?`${chosen.size} ${labels.selected}`:'';items.replaceChildren();if(!chosen.size){const p=document.createElement('p');p.className='tj-bulk__empty';p.textContent=labels.empty;items.append(p);return}chosen.forEach((p,key)=>{const row=document.createElement('div');row.className='tj-bulk__item';const info=document.createElement('div');info.className='tj-bulk__item-info';if(p.image){const image=document.createElement('img');image.className='tj-bulk__item-image';image.src=p.image;image.alt='';info.append(image)}const link=document.createElement('a');link.className='tj-bulk__item-link tj-bulk__item-title';link.href=p.url;link.target='_blank';link.textContent=p.title;info.append(link);const qty=document.createElement('div');qty.className='tj-bulk__qty';const label=document.createElement('label');label.textContent=labels.qty;const input=document.createElement('input');input.className='form-control';input.type='number';input.min='1';input.value=p.quantity;input.addEventListener('change',()=>{p.quantity=Math.max(1,Number(input.value)||1);input.value=p.quantity});label.append(input);qty.append(label);const remove=document.createElement('button');remove.type='button';remove.className='tj-bulk__remove';remove.textContent=labels.remove;remove.addEventListener('click',()=>{chosen.delete(key);render()});row.append(info,qty,remove);items.append(row)})};
    const showResults=products=>{results.replaceChildren();products.forEach(p=>{const button=document.createElement('button');button.type='button';button.className='tj-bulk__result';button.setAttribute('role','option');const img=document.createElement('img');img.src=p.image||'';img.alt='';const title=document.createElement('strong');title.textContent=p.title;const add=document.createElement('span');add.className='tj-bulk__add';add.textContent=labels.add;button.append(img,title,add);button.addEventListener('click',()=>{const key=p.url;chosen.set(key,{title:p.title,url:p.url,quantity:chosen.get(key)?.quantity||1});render();results.replaceChildren();search.value='';search.setAttribute('aria-expanded','false')});results.append(button)});search.setAttribute('aria-expanded',products.length?'true':'false')};
    search.addEventListener('input',()=>{clearTimeout(timer);const q=search.value.trim();if(q.length<2){results.replaceChildren();return}timer=setTimeout(async()=>{spinner.hidden=false;try{const url=`${window.Shopify?.routes?.root||'/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`;const response=await fetch(url);const json=await response.json();showResults(json.resources?.results?.products||[])}catch(e){showResults([])}finally{spinner.hidden=true}},250)});
    form.addEventListener('submit',event=>{if(!chosen.size){event.preventDefault();error.hidden=false;items.scrollIntoView({behavior:'smooth',block:'center'});return}error.hidden=true;body.value='BULK ORDER REQUEST\n\n'+[...chosen.values()].map((p,i)=>`${i+1}. ${p.title}\nQuantity: ${p.quantity}\nProduct: ${location.origin}${p.url}`).join('\n\n')});const params=new URLSearchParams(location.search),productHandle=params.get('product');if(productHandle){fetch(`${window.Shopify?.routes?.root||'/'}products/${encodeURIComponent(productHandle)}.js`).then(r=>r.ok?r.json():Promise.reject()).then(p=>{chosen.set(p.url,{title:p.title,url:p.url,image:p.featured_image,quantity:1});root.classList.add('tj-bulk--product-selected');render()}).catch(()=>{})}render()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subcategory-collcetion-page"] && !Shopify.designMode) return;
  try {
    
  function mountCategoryDirectory(section) {
    if (section.dataset.directoryReady) return;
    section.dataset.directoryReady = 'true';
    const tabs = [...section.querySelectorAll('[data-directory-tab]')];
    const panes = [...section.querySelectorAll('[data-directory-pane]')];
    const layout = section.querySelector('.tej-directory__layout');
    const rail = section.querySelector('.tej-directory__rail');
    const content = section.querySelector('[data-directory-content]');
    if (!tabs.length || !layout || !rail || !content) return;
    const controller = new AbortController();
    const signal = controller.signal;
    let activeIndex = 0;
    let frame = 0;

    function updateBounds() {
      frame = 0;
      if (!matchMedia('(max-width: 749px)').matches) {
        section.style.removeProperty('--directory-mobile-height');
        return;
      }
      const viewport = window.visualViewport;
      const viewportTop = viewport?.offsetTop || 0;
      const viewportBottom = viewportTop + (viewport?.height || innerHeight);
      let bottom = viewportBottom;
      document.querySelectorAll('mobile-sticky-bar, .mobile-sticky-bar, .mobile-bottom-navigation').forEach(bar => {
        const rect = bar.getBoundingClientRect();
        if (rect.height > 0 && rect.top < bottom && rect.bottom > viewportBottom - 12) bottom = rect.top;
      });
      const rect = layout.getBoundingClientRect();
      const top = Math.max(viewportTop + 4, rect.top);
      const available = Math.max(220, Math.floor(bottom - top - 6));
      section.style.setProperty('--directory-mobile-height', `${available}px`);
    }
    function scheduleBounds() { if (!frame) frame = requestAnimationFrame(updateBounds); }
    function activate(index,{focus=false,updateHash=true}={}) {
      if (!tabs[index]) return;
      activeIndex = index;
      tabs.forEach((tab,tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',String(active));
        tab.tabIndex = active ? 0 : -1;
        panes[tabIndex].hidden = !active;
      });
      if (focus) tabs[index].focus({preventScroll:true});
      content.scrollTop = 0;
      const tabRect = tabs[index].getBoundingClientRect();
      const railRect = rail.getBoundingClientRect();
      if (tabRect.top < railRect.top + 5) rail.scrollTop -= railRect.top + 5 - tabRect.top;
      else if (tabRect.bottom > railRect.bottom - 5) rail.scrollTop += tabRect.bottom - railRect.bottom + 5;
      if (updateHash) {
        const url = new URL(location.href);
        url.hash = `category-${tabs[index].dataset.key}`;
        history.replaceState(null,'',url);
      }
      scheduleBounds();
    }
    function restore() {
      let key = '';
      try { key = decodeURIComponent(location.hash.slice(1)).replace(/^category-/,''); } catch (_) {}
      if (key === 'levelo') key = 'smart-home-electronics';
      if (key === 'excelmed') key = 'personal-care';
      const index = tabs.findIndex(tab => tab.dataset.key === key);
      activate(index >= 0 ? index : activeIndex,{updateHash:false});
    }
    tabs.forEach((tab,index) => {
      tab.addEventListener('click',() => activate(index),{signal});
      tab.addEventListener('keydown',event => {
        const map = {ArrowDown:(index+1)%tabs.length,ArrowUp:(index-1+tabs.length)%tabs.length,Home:0,End:tabs.length-1};
        if (!(event.key in map)) return;
        event.preventDefault();
        activate(map[event.key],{focus:true});
      },{signal});
    });
    window.addEventListener('resize',scheduleBounds,{passive:true,signal});
    window.addEventListener('scroll',scheduleBounds,{passive:true,signal});
    window.addEventListener('hashchange',restore,{signal});
    window.addEventListener('pageshow',() => { restore(); scheduleBounds(); },{signal});
    window.visualViewport?.addEventListener('resize',scheduleBounds,{passive:true,signal});
    window.visualViewport?.addEventListener('scroll',scheduleBounds,{passive:true,signal});
    const observer = new ResizeObserver(scheduleBounds);
    document.querySelectorAll('header.header, .header-section.header-sticky, mobile-sticky-bar, .mobile-sticky-bar, .mobile-bottom-navigation').forEach(element => observer.observe(element));
    updateBounds();
    restore();
    section.directoryCleanup = () => { controller.abort(); observer.disconnect(); if (frame) cancelAnimationFrame(frame); };
  }
  function mountDirectories(root=document) { root.querySelectorAll('[data-directory]').forEach(mountCategoryDirectory); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => mountDirectories()); else mountDirectories();
  document.addEventListener('shopify:section:load',event => mountDirectories(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-directory]').forEach(section => section.directoryCleanup?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tejjari-category-shortcuts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-brand-slider-button]');
    if (!button) return;

    const section = button.closest('[data-brand-slider]');
    const scroller = section?.querySelector('.tejjari-brand-shortcuts__scroller');
    if (!scroller) return;

    const direction = button.dataset.brandSliderButton === 'next' ? 1 : -1;
    const rtlMultiplier = getComputedStyle(scroller).direction === 'rtl' ? -1 : 1;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    scroller.scrollBy({
      left: direction * rtlMultiplier * Math.max(scroller.clientWidth * 0.82, 240),
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  });

  } catch(e) { console.error(e); }
})();
})();
